module.exports = __webpack_public_path__ + "media/images/Biochemie-922e5141d2f02fe16f10999ec376d01f.jpg";